// src/Pages/CoreModules/LivestockPopulation.jsx
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SummaryCards from "../../component/Livestock/SummaryCards";
import PopulationDataTable from "../../component/Livestock/Population/PopulationDataTable";
import UnconfiguredSubmodulePlaceholder from "../../component/shared/UnconfiguredSubmodulePlaceholder";
import { useAuth } from "../../context/AuthContext";
import { canCreateModule, MODULE_KEYS } from "../../config/rbacConfig";
import { useModuleTabs } from "../../config/moduleCatalog";

const LOCAL_TABS = [{ key: "livestock-population-record", label: "Livestock Population Records" }];

function TabNav({ tabs, active, onChange }) {
  return (
    <nav className="mb-5 flex flex-wrap gap-x-7 gap-y-2 border-b border-gray-200">
      {tabs.map(({ key, label }) => {
        const isActive = active === key;
        return (
          <button
            key={key}
            onClick={() => onChange(key)}
            className={`relative pb-3 text-sm ${
              isActive ? "font-semibold text-green-600" : "font-medium text-gray-700 hover:text-green-700"
            }`}
          >
            {label}
            {isActive && <span className="absolute inset-x-0 -bottom-px h-0.5 rounded bg-green-600" />}
          </button>
        );
      })}
    </nav>
  );
}

export default function LivestockPopulation() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const tabs = useModuleTabs("livestock-population", LOCAL_TABS);
  const segment = pathname.split("/").filter(Boolean).pop();
  const activeTab = tabs.some((tab) => tab.key === segment) ? segment : tabs[0]?.key;
  const activeTabDef = tabs.find((tab) => tab.key === activeTab);
  const { permissions, user } = useAuth();
  const canCreate = canCreateModule(permissions, MODULE_KEYS.POPULATION) &&
    ["R01", "R04", "R05"].includes(user?.roleId);
  const isR05 = user?.roleId === "R05";

  return (
    <div className="p-6 bg-white min-h-screen">
      <TabNav tabs={tabs} active={activeTab} onChange={(key) => navigate(`/livestock-population/${key}`)} />

      {activeTabDef?.isCatalogOnly ? (
        <UnconfiguredSubmodulePlaceholder label={activeTabDef.label} />
      ) : (
        <>
          <SummaryCards />
          <PopulationDataTable
            canCreate={canCreate}
            hideFilters={isR05}
          />
        </>
      )}
    </div>
  );
}
